<div class="project-logbook-properties">
  <ng-container [ngSwitch]="event.type">
    <!-- VERSION STATUS EVENT PROPERTIES -->
    <div class="status" *ngSwitchCase="STATUS_UPDATED">
      <div class="status-main">
        <h3>This Artwork is</h3>
        <span [style.background-color]="properties.status.color">{{properties.status.name}}</span>
      </div>
    </div>
    <!-- VERSION FEEDBACK APPROVAL UPDATED EVENT PROPERTIES -->
    <div class="approvals-updated" *ngSwitchCase="APPROVAL_STATUS_UPDATED">
      <div class="approval-box-action">
        <figure *ngIf="properties.status.status_code == 1" class="action-icon approve-ico"></figure>
        <figure *ngIf="properties.status.status_code == 2"  class="action-icon reject-ico"></figure>
        <div class="content">
          <div class="message-text" [innerHTML]="properties.status.message">{{properties.status.message}}</div>
        </div>
      </div>
    </div>
    <!-- VERSION FEEDBACK UPDATED EVENT PROPERTIES -->
    <div class="approvals-updated" *ngSwitchCase="VERSION_FEEDBACK_UPDATED">

      <ng-container *ngIf="properties.status == FEEDBACK_STATUS_CODES.ARCHIVED_CODE else feedbackcompleted" >
        <h3>The feedback was {{FEEDBACK_STATUS_TEXTS.ARCHIVED_TEXT}}
          <!-- TODO dec-2023: Archived should have the same details as the request -->
        </h3>
      </ng-container>
      <ng-template #feedbackcompleted>
        <h3>The feedback was 
          <!-- Archived should have the user recipient who was archived for -->
          <span>{{ properties.status == FEEDBACK_STATUS_CODES.OPENED_CODE ? FEEDBACK_STATUS_TEXTS.OPENED_TEXT : FEEDBACK_STATUS_TEXTS.CLOSED_TEXT}}</span>
        </h3>
      </ng-template>
      <core-versions-summary-box
          [version]="properties.version"
          [menu]="menu"
          [feedbacks]="feedbacks"
          (menuClick)="onMenuClick($event)"
          (actionFileClick)="onClickPreview($event)"
      ></core-versions-summary-box>
    </div>
    <!-- PROBABLY will be updated with new information along 2024 (Isaac said that...) -->
    <!-- SHARE VERSION UPLOAD UPDATED EVENT PROPERTIES -->
    <div class="approvals-updated" *ngSwitchCase="VERSION_UPLOAD_VERSION_UPDATED">
      <ng-container *ngIf="properties.status == UPLOAD_VERSION_STATUS_CODES.ARCHIVED_CODE else uploadversioncompleted" >
        <h3>The feedback was {{FEEDBACK_STATUS_TEXTS.ARCHIVED_TEXT}}
          <!-- TODO dec-2023: Archived should have the same details as the request -->
        </h3>
      </ng-container>
      <ng-template #uploadversioncompleted>
        <h3>The feedback was 
          <!-- Archived should have the user recipient who was archived for -->
          <span>{{FEEDBACK_STATUS_TEXTS.CLOSED_TEXT}}</span>
        </h3>
      </ng-template>
      <core-versions-summary-box
          [version]="properties.version"
          [menu]="menu"
          [feedbacks]="feedbacks"
          (menuClick)="onMenuClick($event)"
          (actionFileClick)="onClickPreview($event)"
      ></core-versions-summary-box>
    </div>


    <!-- Defualt case when same code for multiple options-->
    <ng-container *ngSwitchDefault>
      <!-- VERSION LABELS EVENT PROPERTIES -->
      <div class="label" *ngIf="event.type == LABEL_ADDED || event.type == LABEL_REMOVED">
        <core-label [label]="properties.label"></core-label>
      </div>
      <!-- VERSION MESSAGE EVENT PROPERTIES -->
      <div class="message" *ngIf="event.type == MESSAGE_ADDED || event.type == MESSAGE_REMOVED">
        <core-message
          [message]="properties.message"
          [notesActionText]="'See Notes'"
          [notesActionStyle]="'see-notes'"
          [canCreateNotes]="false"
          [delete]="false"
          [prefixUrl]="messagePrefixUrl"
        ></core-message>
      </div>
    </ng-container>
  </ng-container>
</div>
